import { createTheme, ThemeOptions } from "@mui/material/styles";
import { deepPurple, teal, pink } from "@mui/material/colors";

function createCustomTheme() {
  const themeProps: ThemeOptions = {
    spacing: 8,
    components: {
      MuiAppBar: {
        styleOverrides: {
          root: {
            backgroundColor: "#ffffff",
            backgroundImage: "none",
          },
        },
      },
    },
    palette: {
      background: { default: "#ffffff" },
      primary: {
        main: "#2a2a3b",
      },
      secondary: {
        main: deepPurple[800],
      },
      success: {
        main: teal[600],
      },
      error: {
        main: pink[600],
      },
      // mode: 'dark',
    },
    typography: {
      button: {
        textTransform: "none",
      },
      fontFamily: '"Zen Kaku Gothic New", helvetica, "sans-serif"',
      fontSize: 14,
    },
  };
  return createTheme(themeProps);
}

export const CustomTheme = createCustomTheme();

CustomTheme.typography.h1 = {
  fontSize: "2rem",
  fontWeight: "bold",
  [CustomTheme.breakpoints.up("sm")]: {
    fontSize: "4rem",
  },
  [CustomTheme.breakpoints.up("md")]: {
    fontSize: "6rem",
  },
};
CustomTheme.typography.h2 = {
  fontSize: "1.8rem",
  fontWeight: "bold",
  [CustomTheme.breakpoints.up("sm")]: {
    fontSize: "2.5rem",
  },
  [CustomTheme.breakpoints.up("md")]: {
    fontSize: "3rem",
  },
};

CustomTheme.typography.h3 = {
  fontSize: "1.6rem",
  fontWeight: "bold",
  [CustomTheme.breakpoints.up("sm")]: {
    fontSize: "1.8rem",
  },
  [CustomTheme.breakpoints.up("md")]: {
    fontSize: "2.3rem",
  },
};

CustomTheme.typography.h5 = {
  fontSize: "1.6rem",
  [CustomTheme.breakpoints.up("sm")]: {
    fontSize: "2rem",
  },
  [CustomTheme.breakpoints.up("md")]: {
    fontSize: "3rem",
  },
};

CustomTheme.typography.body1 = {
  fontSize: "1.4rem",
  [CustomTheme.breakpoints.up("sm")]: {
    fontSize: "1.6rem",
  },
  [CustomTheme.breakpoints.up("md")]: {
    fontSize: "1.8rem",
  },
};
